import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import ProfilePasForm from '../../components/profilemng/ProfilePasForm';
import * as authApi from '../../lib/api/auth';

const ProfiePassContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  let initialValues = {
    currentPassword: '',
    changedPassword: '',
    changedConfirmPassword: '',
  };

  const validationSchema = yup.object({
    currentPassword: yup.string('').required('현재 비밀번호를 입력하세요'),
    changedPassword: yup.string().required('변경할 비밀번호를 입력하세요'),
    changedConfirmPassword: yup
      .string()
      .required('변경 비밀번호 확인을 입력하세요')
      .test(
        'passwords-match',
        '변경비밀번호는 비밀번호 확인과 일치해야합니다.',
        function (value) {
          return this.parent.changedPassword === value;
        },
      ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        currentPassword: values.currentPassword,
        changedPassword: values.changedPassword,
      };

      try {
        const res = await authApi.changePwd(dataToSubmit);
        if(res.data.result){
          enqueueSnackbar('비밀번호 변경 성공', {
            variant: 'success',
          });
        }else{
          enqueueSnackbar('비밀번호 변경에 실패하였습니다.', {
            variant: 'error',
          });
        }
        
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  

  return <ProfilePasForm formik={formik} />;
};

export default ProfiePassContainer;
